import React, { forwardRef } from 'react';
import './FlyingSliderArrow.css';
import classNames from 'classnames';
import { SvgIconMask } from '../SvgIconMask';
import arrowIcon from '../../../images/flying-slider-arrow.svg';

export const FlyingSliderArrowTypesEnum = {
    PREV: 'prev',
    NEXT: 'next',
};

export const FlyingSliderArrow = forwardRef(({
    arrowType = FlyingSliderArrowTypesEnum.PREV,
    extraClass = '',
    onClick,
}, ref) => {
    const buttonClasses = classNames(
        'flying-slider-arrow',
        `flying-slider-arrow--${arrowType}`,
        {
            [extraClass]: !!extraClass,
            [`${extraClass}--${arrowType}`]: !!extraClass,
        }
    );
    const arrowClasses = classNames(
        'flying-slider-arrow__arrow',
        `flying-slider-arrow__arrow--${arrowType}`,
        {
            [`${extraClass}__arrow`]: !!extraClass,
            [`${extraClass}__arrow--${arrowType}`]: !!extraClass,
        }
    );

    return <button className={buttonClasses}
        ref={ref}
        onClick={onClick}>
        <SvgIconMask
            className={arrowClasses}
            iconUrl={arrowIcon}
            width={16}
            height={28}
            bgColor="var(--arrow-color, #fff)"
        />
    </button>;
});

FlyingSliderArrow.displayName = 'FlyingSliderArrow';
